import type { EvalAction } from "@repo/schema";
import { formOptions } from "@tanstack/react-form";

/**
 * The slice of form state that both the limit form and the test-case form carry,
 * so the shared action editor can read either of them out of form context
 * instead of being duplicated per form shape.
 */
export const evalActionsFormOptions = formOptions({
  defaultValues: { actions: [] as EvalAction[] },
});
